import * as React from 'react';
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Provider } from "react-redux";
import store from "./store";
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { QueryClient, QueryClientProvider } from 'react-query';

LicenseInfo.setLicenseKey(
  'dc9a8ba0773c938df499261543ca34aaTz01NTI5NixFPTE3MDEzODg1ODQ3NzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
const queryClient = new QueryClient()

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <App />
        </ThemeProvider>
      </LocalizationProvider>
    </Provider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
